import { Component, input } from '@angular/core';
import { IsActiveMatchOptions, RouterLink, RouterLinkActive } from '@angular/router';
import { DokaIcon } from '@doka/angular-core';
import { I18NextEagerPipe } from 'angular-i18next';

export interface SidebarEntry {
  route: string;
  icon: string;
  label: string;
  exact?: boolean;
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  host: {
    class: 'w-[80px] shrink-0 h-full border-r border border-border-ultra-light bg-background-gray-ultra-light',
  },
  imports: [DokaIcon, RouterLink, RouterLinkActive, I18NextEagerPipe],
})
export class SidebarComponent {
  public readonly entries = input.required<SidebarEntry[]>();

  protected readonly exactMatch: IsActiveMatchOptions = {
    paths: 'exact',
    queryParams: 'ignored',
    matrixParams: 'ignored',
    fragment: 'ignored',
  };
}
